import { useTranslation } from 'react-i18next';

import { useAlertDialog } from '@/components/ui/alert-dialog';
import { useAbility } from '@/hooks/ability';
import api from '@/services/api/api';
import { useMutation } from '@tanstack/react-query';

type UserNotificationOperationConfigFormData = {
  status: string[];
  user_id: string;
  message_id: string;
};

export const useStoreUserNotificationOperationConfigMutation = () => {
  const { alert } = useAlertDialog();
  const { t } = useTranslation();

  const ability = useAbility();

  return useMutation({
    mutationFn: async (data: UserNotificationOperationConfigFormData) => {
      if (!ability.can('admin.message.index', '')) {
        return alert({
          title: t('no-permission'),
          description: t('you-dont-have-permission-to-do-that'),
          type: 'error',
        });
      }
      const response = await api.put(`admin/user/${data.user_id}/message-team-credit-status`, {
        message_id: data.message_id,
        user_id: data.user_id,
        team_credit_status: data.status,
      });
      return response.data.data;
    },
    mutationKey: ['storeUserNotificationOperationConfig'],
  });
};
